const reduceToUniqueArray = (items = [], key = "") => {
  if (items.length === 0) return null;
  if (key === "") throw new Error("Missing key param");
  return [...new Map(items.map((item) => [item[key], item])).values()];
};

export default reduceToUniqueArray;
